import React from 'react'
import { Shield, Heart, Award, Lightbulb, CheckCircle, Users } from 'lucide-react'

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-12 ">
      <div className="max-w-7xl mx-auto">
        
      <section className="mb-16 bg-gray-900 py-16 px-6">
          <h2 className="text-3xl font-semibold text-center text-white mb-6">Our Mission & Vision</h2>
          <p className="text-xl text-center text-gray-300 mb-8">
            Embracing growth through adaptability and resilience.
          </p>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-800 p-6 rounded-lg shadow-md text-white">
              <div className="mb-4 flex justify-start">
                <Lightbulb className="w-12 h-12 text-yellow-500" />
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-left">Mission</h3>
              <p>
                To deliver excellent solutions for addressing the current challenges in user experience within the real estate industry.
              </p>
            </div>
            <div className="bg-gray-800 p-6 rounded-lg shadow-md text-white">
              <div className="mb-4 flex justify-start">
                <Award className="w-12 h-12 text-blue-500" />
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-left">Vision</h3>
              <p>
                To be a foremost brand known to challenge the real estate status quo by providing luxury experiences in Africa.
              </p>
            </div>
          </div>
        </section>
        
        <section>
          <h2 className="text-3xl font-semibold text-center text-gray-800 mb-12">Our Values</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ValueCard 
              icon={<Shield className="w-12 h-12 text-blue-500" />}
              title="Confidentiality"
              description="We are committed to protecting the personal and financial information of our clients, partners, and other stakeholders."
            />
            <ValueCard 
              icon={<Heart className="w-12 h-12 text-red-500" />}
              title="Integrity"
              description="We are committed to the highest standards of honesty and ethics in all our dealings. Trust is the foundation of our business."
            />
            <ValueCard 
              icon={<Award className="w-12 h-12 text-yellow-500" />}
              title="Quality"
              description="We continually pursue excellence in everything we do, from customer service to property management, to deliver the best possible outcomes."
            />
            <ValueCard 
              icon={<Lightbulb className="w-12 h-12 text-green-500" />}
              title="Innovation"
              description="We embrace innovation and adapt to evolving real estate technologies and trends to better serve our clients and stay ahead in the market."
            />
            <ValueCard 
              icon={<CheckCircle className="w-12 h-12 text-purple-500" />}
              title="Accountability"
              description="We take responsibility for our actions, delivering on promises and commitments, and holding ourselves and our team members accountable for our performance."
            />
            <ValueCard 
              icon={<Users className="w-12 h-12 text-indigo-500" />}
              title="Customer-Centric"
              description="We prioritize the needs and goals of our clients above all else, striving to exceed their expectations at every opportunity."
            />
          </div>
        </section>
      </div>
    </div>
  );
};

const ValueCard = ({ icon, title, description }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md shadow-slate-100 flex flex-col  text-left">
      <div className="mb-4">
        {icon}
      </div>
      <h3 className="text-xl text-left font-semibold text-gray-800 mb-2">{title}</h3>
      <p className="text-gray-600 text-left">{description}</p>
    </div>
  );
};

export default AboutUs;
